baseApp.service('SitePopLocationService', ['GeneralUtilsService', function(GeneralUtilsService) {

    let sitePopLocationService = {};

    var fetchData = function(region, accountId, callback) {
        store.fetch({
            path: '/sitePopLocations',
            queryParams: { licenseRegion: region,
                           accountId: accountId },
            success: function (data) {
                callback({
                    pops: data,
                });
            }
        })
    };

    sitePopLocationService.getPops = function(region, accountId, callback) {
        fetchData(region, accountId, function(data) {
            callback(data);
        });
    };

    return sitePopLocationService;
}]);